import React from 'react';
import ContactForm from '../ContactForm/ContactForm';
import './ContactSection.css';

const ContactSection = () => {
  return (
    <section className="contact-section container">
      <div className="contact-content">
        <ContactForm />
        <div className="contact-info">
          {/* <div className="info-card">
            <div className="icon-container">
              <i className="fas fa-phone"></i>
            </div>
            <h3>电话</h3>
            <p>
              <img src="/images/flags/us.png" alt="US" /> +1 309 791 4105
            </p>
            <p>
              <img src="/images/flags/in.png" alt="India" /> +91 8000 161 161
            </p>
          </div> */}

          <div className="info-card">
            <div className="icon-container">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <h3>地址</h3>
            <p>河北省唐山市路北区茂华金汇公馆6层618室</p>
          </div>

          {/* <div className="info-card">
            <div className="icon-container">
              <i className="fab fa-skype"></i>
            </div>
            <h3>Skype</h3>
            <p>hyperlink.infosystem</p>
          </div> */}

          {/* <div className="info-card">
            <div className="icon-container">
              <i className="fas fa-envelope"></i>
            </div>
            <h3>邮箱</h3>
            <p>info@hyperlinkinfosystem.com</p>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 